import BasicComponent from './BasicComponent';
import { NavigationDirection } from '@/models/navigation-direction';

class Steps extends BasicComponent {
  constructor(component: any) {
    super(component);

    this._computed = {
      steps() {
        return this.$store.getters.getSteps;
      },

      activeStep() {
        return this.$store.getters.getActiveStep;
      },
  
      activeStepId() {
        return this.steps.indexOf(this.activeStep);
      },
  
      isFirstStep() {
        return this.activeStepId === 0;
      },

      isLastStep() {
        return this.activeStepId === this.$store.getters.getSteps.length - 1;
      },
    }

    this._methods = {
      prev() {
        this.$store.commit('navigateToDirection', NavigationDirection.PREVIEW);
      },
      next() {
        this.$store.commit('navigateToDirection', NavigationDirection.NEXT);
      },
      to(step: Steps) {
        this.$store.commit('navigateToStep', step);
      },
      submit() {
        this.$store.dispatch('submitForm');
      }
    }

    this.addImplementKeys(['methods', 'computed']);
  }
}

export default Steps;
